import { createSelector } from 'reselect';

export const productDetailsSelector = createSelector(
  state => state.product,
  product => product.details,
);
